import request from '@/api/request'

// 提交意见反馈
export function submitFeedback(data) {
  return request.post('/api/mini/feedback/submit', data)
}
